var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import moment from 'moment';
import { downloadBlob } from './commonUtilities';
export var EXPORT_FORMAT_OPTIONS = [
    { format: 'xlsx', label: 'Excel (.xlsx)' },
    { format: 'csv', label: 'CSV (.csv)' },
];
export var EXPORT_NUMBER_FORMATS = {
    currency: '$#,##0.00',
};
var MIME_TYPES = {
    csv: 'text/csv;charset=utf-8;',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
var toSafeFileSegment = function (text) { return text.trim().replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'Export'; };
var escapeCsvCell = function (value) { return "\"".concat(String(value).replace(/"/g, '""'), "\""); };
var buildCsv = function (matrix) { return matrix.map(function (row) { return row.map(escapeCsvCell).join(','); }).join('\r\n'); };
var buildXlsx = function (matrix, columns, sheetName) { return __awaiter(void 0, void 0, void 0, function () {
    var XLSX, worksheet, workbook;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, import('xlsx')];
            case 1:
                XLSX = _a.sent();
                worksheet = XLSX.utils.aoa_to_sheet(matrix);
                worksheet['!cols'] = columns.map(function (column) { var _a; return ({ wch: (_a = column.width) !== null && _a !== void 0 ? _a : column.header.length + 4 }); });
                columns.forEach(function (column, columnIndex) {
                    if (!column.numberFormat)
                        return;
                    for (var rowIndex = 1; rowIndex < matrix.length; rowIndex += 1) {
                        var cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: columnIndex })];
                        if (cell && cell.t === 'n')
                            cell.z = column.numberFormat;
                    }
                });
                workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
                return [2, XLSX.write(workbook, { type: 'array', bookType: 'xlsx' })];
        }
    });
}); };
export var exportTable = function (_a) {
    var rows = _a.rows, columns = _a.columns, format = _a.format, fileName = _a.fileName, sheetName = _a.sheetName, _b = _a.emptyValue, emptyValue = _b === void 0 ? '--' : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var matrix, fullFileName, content, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    matrix = __spreadArray([
                        columns.map(function (column) { return column.header; })
                    ], rows.map(function (row) { return columns.map(function (column) {
                        var value = column.value(row);
                        return value === null || value === undefined || value === '' ? emptyValue : value;
                    }); }), true);
                    fullFileName = "".concat(toSafeFileSegment(fileName), "_").concat(moment().format('YYYY-MM-DD_HHmm'), ".").concat(format);
                    if (!(format === 'csv')) return [3, 1];
                    _c = ['﻿', buildCsv(matrix)];
                    return [3, 3];
                case 1: return [4, buildXlsx(matrix, columns, sheetName !== null && sheetName !== void 0 ? sheetName : fileName)];
                case 2:
                    _c = [_d.sent()];
                    _d.label = 3;
                case 3:
                    content = _c;
                    downloadBlob(new Blob(content, { type: MIME_TYPES[format] }), fullFileName);
                    return [2];
            }
        });
    });
};
